import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const [token, setToken] = useState(params.get("token") || "");
    const [pw, setPw] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            toast.success("Password updated. Please sign in.");
            nav("/login");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <main data-testid="reset-page" className="min-h-screen bg-black flex items-center justify-center px-6 pt-24 pb-12">
            <div className="w-full max-w-md">
                <Link to="/" className="font-serif text-3xl block mb-12">Tile<span className="text-gold">Sphere</span></Link>
                <div className="overline mb-3">Reset Password</div>
                <h1 className="font-serif text-4xl mb-10 tracking-tight">Set a new password.</h1>
                <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
                    <input required placeholder="Reset token" value={token} onChange={(e)=>setToken(e.target.value)} className="w-full bg-[#0a0a0a] border border-white/15 px-4 py-4 focus:border-gold focus:outline-none" data-testid="reset-token" />
                    <input required type="password" placeholder="New password (min 6)" value={pw} onChange={(e)=>setPw(e.target.value)} className="w-full bg-[#0a0a0a] border border-white/15 px-4 py-4 focus:border-gold focus:outline-none" data-testid="reset-password" />
                    <button disabled={busy} type="submit" className="btn-gold w-full" data-testid="reset-submit">{busy ? "Updating…" : "Reset password"}</button>
                </form>
            </div>
        </main>
    );
}
